const metaConfig = {
    "/": {
        title: "Boards, Panels & Planks | Top Sustainable Building Materials",
        description: "Choose Vnext for next-level construction — cost-effective, easy-to-install fibre cement boards, panels, and planks that are eco-friendly, fire-resistant, and termite-proof.",
        keywords: "Vnext builders, Vnext projects, Vnext infrastructure, Vnext innovations, Vnext construction, Innovative building services, Modern construction solutions, Smart home construction, Sustainable construction practices, Industrial construction services",
        structuredData: `<script type="application/ld+json">
            {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Vnext Fibre Cement Board",
            "image": "https://s3prodorg.atumanalytics.com/visaka/vnext/website/assets/images/logo.webp",
            "url": "https://vnext.in/",
            "telephone": "+91-8886786398",
            "email": "vnext@visaka.in",
            "address": {
            "@type": "PostalAddress",
            "streetAddress": "Visaka Towers, 1-8-303/69/3, Sardar Patel Rd, Sindhi Colony, Begumpet",
            "addressLocality": "Secunderabad",
            "addressRegion": "Telangana",
            "postalCode": "500003",
            "addressCountry": "IN"
            },
            "openingHoursSpecification": [
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Monday",
                "opens": "09:00",
                "closes": "17:30"
            },
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Tuesday",
                "opens": "09:00",
                "closes": "17:30"
            },
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Wednesday",
                "opens": "09:00",
                "closes": "17:30"
            },
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Thursday",
                "opens": "09:00",
                "closes": "17:30"
            },
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Friday",
                "opens": "09:00",
                "closes": "17:30"
            },
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Saturday",
                "opens": "09:00",
                "closes": "17:30"
            }
            ],
            "sameAs": [
            "https://www.youtube.com/user/vnextbyvisaka",
            "https://www.instagram.com/vnextbyvisaka/",
            "https://x.com/vnext_visaka",
            "https://www.facebook.com/vnextbyvisaka"
            ]
            }
        </script>`
    },
    "/products/vboards": {
        title: "VBoards | Fibre Cement Boards | Fire, Water & Termite‑Resistant",
        description: "Explore Vnext Boards - durable fibre cement boards built for modern construction. Fire, water, and termite-resistant, eco-friendly, and designed for easy installation.",
        keywords: "v board house, v board sheets, v board ceiling, Lightweight construction board, Fire‑resistant board, Waterproof building board, Termite resistant board, Durable wall panel, v board partition, ceiling trap door, v panel board, v board panels, ceiling trap door"
    },
    "/products/vplank": {   
        title: "VPlank by Vnext – Durable Fibre Cement Planks for Exterior Cladding",
        description: "Discover VPlank by Vnext eco-friendly fibre cement planks with wood-like finish. Fire, water & termite-resistant, ideal for facades, fences & more.",
        keywords: "VPlank boards, VPlank construction planks, VPlank panels, Wall cladding planks, Exterior siding planks, Interior wall panels, Outdoor flooring planks"
    },
    "/products/vpremium": {
        title: "VPremium Fibre Cement Boards – Non‑Asbestos, Autoclaved | Vnext",
        description: "VPremium boards combine Hatschek manufacturing with HPSC curing for superior strength. Eco‑friendly, safe, and ideal for modern architectural applications.",
        keywords: "v panel, cement partition wall, v board housecement wall panels, cement panels, v construction, fibre cement board"
    },
    "/products/vpanels": {
        title: "Vnext Panels – Lightweight Non‑Asbestos Wall Solutions",
        description: "Vnext Panels are ready-to-install, lightweight, non‑asbestos panels offering up to 180 min fire resistance, sound & thermal insulation, and easy relocation. Perfect for modern builds.",
        keywords: "cement wall panels, v board panels, VPanels wall panel, VPanels construction boards, VPanels interior cladding, Decorative wall panels India, VPanels exterior panels, Waterproof wall panels, Lightweight building panels, Sound‑insulating panels, Modern wall paneling solutions, VPanels supplier Hyderabad"
    },
    "/products/vframes": {     
        title: "Lightweight & Flexible Vnext Frames for Modern Constructions",
        description: "Discover Vnext Frames a cost-effective, non-load bearing framing system ideal for commercial and residential spaces. Perfect for airports, villas, malls, hospitals & more.",
        keywords:'VFrames framework systems, VFrames structural frames, VFrames construction framing, Metal frames for walls, Lightweight frame panels, VFrames interior partitions, VFrames door/window frames, Durable construction frames, VFrames supplier Hyderabad, VFrames prefab frame solutions'
    },
    "/products/atum": {
        title: "ATUM Solar Roof | Energy-Generating Cement Roof Panels",
        description: "Generate energy while staying protected. ATUM solar roofing panels offer structural strength, insulation, and green power—all in one integrated roofing system.",
        keywords: "atum solar, Atum integrated solar roof, Atum solar roof panels, Solar roofing solutions, Integrated solar roof system, solar roof supplier, Sustainable solar roofing solutions, renewable energy roof"
    },
    "/products": {
        title: "Vnext Product Catalogue – Eco-Friendly & Innovative Building Materials",
        description: "From solar roofing (ATUM) to durable fibre cement boards (VBoards, VPlank), explore Vnext’s complete range of smart, sustainable, and cost-effective products.",
        keywords: "cement sheet home, wall cladding outdoor, cement sheets house, v panel cement partition wall, v board house, cement wall panels, cement panels, v construction, fibre cement board, false ceiling material, v board panels, atum solar, v board sheets, roofing sheet manufacturer, cement sheet for roofing, roof sheeting price, prices for roofing sheets, fibre sheets for roofing, v board ceiling, cement roof, cement board panels, partitions for home, false partition wall, panel partition"
    },
    "/solutions/partitions": {
        title: "Vnext Partitions – Stronger, Greener Alternative to Plywood",
        description: "An eco-friendly alternative to plywood partitions, Vnext's partitions are far more superior in quality and durability in comparison.",
        keywords: "v board partition, readymade wall partitions, partitions for home, false partition wall, panel partition, readymade wall partition, readymade wall for room, readymade partition wall, fiber partition wall, readymade wall partitions, prefab wall panels, wall panels hyderabad, wall panels in hyderabad"
    },
    "/solutions/vplank-gate": {
        title: "Vnext Premium Planks | Durable Gate Cladding Solution",
        description: "Vnext Plank is the perfect choice for secure and stylish gate cladding. Durable, weather-resistant, and termite-proof for residential and commercial use.",
        keywords: "VPlank Gate design, VPlank Gate solutions, Gate cladding with VPlank, VPlank fencing gate, Modern gate panels VPlank, Durable gate boards VPlank, Weatherproof gate panels, Security gate VPlank material, Stylish gate finishes VPlank, cement wooden plank, cement planks, cement plank,"
    },
    "/solutions/false-ceiling": {
        title: "Vnext False Ceiling Solutions | Durable Fibre Cement Boards",
        description: "Vnext false ceiling solutions offer fire, water, and termite resistance with aesthetic appeal. Suitable for concealed grid and T-grid installations.",
        keywords: "false ceiling material, v board ceiling, false ceiling, Vnext False Ceiling Solutions, v board ceiling design",
       
    },
    "/solutions/roof-underlay": {
        title: "Vnext Roof Underlay | Fibre Cement Boards for Sloped Roofing",
        description: "Vnext fibre cement boards offer a rich look and superior performance as roof underlay, replacing sloped RCC slabs with a cost-efficient, maintenance-free option.",
        keywords: "roofing sheet manufacturer, cement sheet for roofing, roof sheeting price, prices for roofing sheets, fibre sheets for roofing, cement roof"
    },
    "/solutions/v-infill": {
        title: "Vnext Infill Cutting – Innovative Lightweight Concrete Walls",
        description: "Build faster and smarter with Vnext Infill Cutting technology. Lightweight concrete poured between Vnext frames offers durable, insulated walls with quick finishing",
        keywords: "VInfill, V‑Infill solution, Infilling systems, Smart infill technology, Infill for buildings, Sustainable infill solutions, Vnext infill"
    },
    "/solutions/cnc-cutting": {
        title: "Vnext CNC Cutting – Precision Crafting on Fibre Cement Boards",
        description: "Bring your imagination to life with Vnext’s CNC cutting technology. Achieve intricate, precise cuts on Vnext Boards for stunning furniture and decor.",
        keywords: "CNC cutting service, CNC cutting in construction, CNC precision cutting, CNC cutting Vnext, CNC for fibre‑cement boards, CNC panel cutting, Digital cutting solutions, Automated cutting services, CNC board cutting, CNC interior detailing, CNC architectural cutting, CNC cutting India, CNC cutting for partitions and ceilings"
    },
    "/solutions/atum": { 
        title: "ATUM Solar Roofing | Integrated Solar Roof with Cement Base",
        description: "Atum is a building integrated solar PV panel with a cementations substrate that reduces thermal conductivity better than a traditional roof.",
        keywords: "atum solar, Atum integrated solar roof, Atum solar roof panels, Solar roofing solutions, Integrated solar roof system, solar roof supplier, Sustainable solar roofing solutions, renewable energy roof"
    },
    "/solutions": {
        title: "Vnext Solutions | Advanced Construction Materials & Applications",
        description: "Discover Vnext's all-in-one construction solutions, including ATUM solar roofing, V-Infill panels, VPremium plank gates, and more for modern buildings.",
        keywords: "cement sheet home, wall cladding outdoor, cement sheets house, v panel cement partition wall, v board house, cement wall panels, cement panels, v construction, fibre cement board, false ceiling material, v board panels, atum solar, v board sheets, roofing sheet manufacturer, cement sheet for roofing, roof sheeting price, prices for roofing sheets, fibre sheets for roofing, v board ceiling, cement roof, cement board panels, partitions for home, false partition wall, panel partition"
    },
    "/applications": {
        title: "Vnext Construction Applications | Modern Building Solutions",
        description: "From internal wall panelling and wardrobes to external facades and roof underlays, Vnext offers high-quality materials for all your construction needs.",
        keywords: "cement sheet home, wall cladding outdoor, cement sheets house, v panel cement partition wall, v board house, cement wall panels, cement panels, v construction, fibre cement board, false ceiling material, v board panels, atum solar, v board sheets, roofing sheet manufacturer, cement sheet for roofing, roof sheeting price, prices for roofing sheets, fibre sheets for roofing, v board ceiling, cement roof, cement board panels, partitions for home, false partition wall, panel partition"
    },
    "/blogs": {
        title: "Vnext Blog | Innovations in Construction Technology",
        description: "Explore Vnext's insights on the latest advancements in construction, sustainable building materials, and innovative design solutions.",
        keywords: "cement sheet home, wall cladding outdoor, cement sheets house, v panel cement partition wall, v board house, cement wall panels, cement panels, v construction, fibre cement board, false ceiling material, v board panels, atum solar, v board sheets, roofing sheet manufacturer, cement sheet for roofing, roof sheeting price, prices for roofing sheets, fibre sheets for roofing, v board ceiling, cement roof, cement board panels, partitions for home, false partition wall, panel partition"
    },
    "/blogs/1": {
        title: "Vnext Blog | Innovations in Construction Technology",
        description: "Explore Vnext's insights on the latest advancements in construction, sustainable building materials, and innovative design solutions.",
        keywords: "cement sheet home, wall cladding outdoor, cement sheets house, v panel cement partition wall, v board house, cement wall panels, cement panels, v construction, fibre cement board, false ceiling material, v board panels, atum solar, v board sheets, roofing sheet manufacturer, cement sheet for roofing, roof sheeting price, prices for roofing sheets, fibre sheets for roofing, v board ceiling, cement roof, cement board panels, partitions for home, false partition wall, panel partition"
    },
    "/blog/what-is-fibre-cement-board": {
        title: "What is Fibre Cement Board? Uses, Advantages & Applications | Vnext",
        description: "Fibre cement board is a durable building material used for walls, ceilings, facades, and partitions. Learn its uses, advantages, lifespan, and applications.",
        keywords: "",
        structuredData: `<script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "LocalBusiness",
          "name": "Vnext",
          "image": "https://s3prodorg.atumanalytics.com/visaka/vnext/website/assets/images/logo.webp",
          "telephone": "8886786398",
          "url": "https://vnext.in/products"
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What is fibre cement board?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Fibre cement board is a durable construction material made from cement, cellulose fibres, and mineral additives. It is used for walls, ceilings, facades, and partitions due to its fire resistance and moisture resistance."
              }
            },
            {
              "@type": "Question",
              "name": "Is fibre cement board waterproof?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Fibre cement boards are moisture-resistant but not completely waterproof. Proper sealing is required for areas with continuous water exposure."
              }
            },
            {
              "@type": "Question",
              "name": "Can fibre cement boards be used for exterior walls?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, fibre cement boards are suitable for exterior walls due to their strength, weather resistance, and long service life."
              }
            },
            {
              "@type": "Question",
              "name": "How long do fibre cement boards last?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Fibre cement boards typically last between 25 and 50 years when installed correctly and maintained properly."
              }
            }
          ]
        }
      ]
    }
    </script>`
    },
    "/blog/8-tips-for-incorporating-fibre-cement-boards-in-eco-friendly-projects": {
        title: "8 Tips for Using Fibre Cement Boards in Eco-Friendly Projects | Vnext",
        description: "Learn how to use fibre cement boards in sustainable construction with these 8 expert tips. Enhance durability while reducing environmental impact with Vnext.",
        keywords: "",
        structuredData: ""
    },
    "/blog/rains-arriving-early-are-you-weather-ready": {
        title: "Rainwater-Resistant Fibre Cement Boards vs Plywood & Gypsum | Vnext",
        description: "Discover why Vnext fibre cement boards are the ideal rainwater-resistant alternative to plywood and gypsum. Protect your interiors and exteriors from moisture, mould, and weather damage.",
        keywords: "",
        structuredData: ""
    },
    "/coverages": {
        title: "Vnext Coverages | Nationwide Construction Solutions",
        description: "Discover Vnext's extensive coverage across India, offering sustainable and innovative construction solutions for residential and commercial projects.",
        keywords: "cement sheet home, wall cladding outdoor, cement sheets house, v panel cement partition wall, v board house, cement wall panels, cement panels, v construction, fibre cement board, false ceiling material, v board panels, atum solar, v board sheets, roofing sheet manufacturer, cement sheet for roofing, roof sheeting price, prices for roofing sheets, fibre sheets for roofing, v board ceiling, cement roof, cement board panels, partitions for home, false partition wall, panel partition"
    },
    "/videos": {
        title: "Vnext Video Gallery | Innovative Building Solutions",
        description: "Watch Vnext's videos to discover eco-friendly building materials, design inspirations, and successful project implementations across India.",
        keywords: "cement sheet home, wall cladding outdoor, cement sheets house, v panel cement partition wall, v board house, cement wall panels, cement panels, v construction, fibre cement board, false ceiling material, v board panels, atum solar, v board sheets, roofing sheet manufacturer, cement sheet for roofing, roof sheeting price, prices for roofing sheets, fibre sheets for roofing, v board ceiling, cement roof, cement board panels, partitions for home, false partition wall, panel partition"
    },
    "/contact": {
        title: "Contact Vnext | Connect with Our Experts",
        description: "Get in touch with Vnext for inquiries about our eco-friendly construction products and services. We're happy to assist you",
        keywords: "cement sheet home, wall cladding outdoor, cement sheets house, v panel cement partition wall, v board house, cement wall panels, cement panels, v construction, fibre cement board, false ceiling material, v board panels, atum solar, v board sheets, roofing sheet manufacturer, cement sheet for roofing, roof sheeting price, prices for roofing sheets, fibre sheets for roofing, v board ceiling, cement roof, cement board panels, partitions for home, false partition wall, panel partition"
    }
}

export default metaConfig;